import NextLink from 'next/link';

import { mkAssetUrl } from '@lib/utils';

import type { ComponentProps, FC } from 'react';

export type LinkProps = Omit<ComponentProps<typeof NextLink>, 'href'> & { route: string };

export const Link: FC<LinkProps> = (props) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <NextLink {...props} href={mkAssetUrl(props.route)} />
);
